import React from 'react';
import { StarIcon } from 'lucide-react';
interface RatingProps {
  value: number;
  reviewCount?: number;
  showCount?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizeStyles = {
  sm: {
    star: 'w-3.5 h-3.5',
    text: 'text-xs'
  },
  md: {
    star: 'w-4 h-4',
    text: 'text-sm'
  },
  lg: {
    star: 'w-5 h-5',
    text: 'text-base'
  }
};
export function Rating({
  value,
  reviewCount,
  showCount = true,
  size = 'md',
  className = ''
}: RatingProps) {
  const fullStars = Math.floor(value);
  const hasHalfStar = value % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  return <div className={`flex items-center gap-1.5 ${className}`} data-id="element-324">
      <div className="flex items-center" aria-label={`Рейтинг: ${value} з 5`} data-id="element-325">
        {[...Array(fullStars)].map((_, i) => <StarIcon key={`full-${i}`} className={`${sizeStyles[size].star} text-amber-400 fill-amber-400`} data-id="element-326" />)}
        {hasHalfStar && <div className="relative" data-id="element-327">
            <StarIcon className={`${sizeStyles[size].star} text-slate-200 fill-slate-200`} data-id="element-328" />
            <div className="absolute inset-0 overflow-hidden w-1/2" data-id="element-329">
              <StarIcon className={`${sizeStyles[size].star} text-amber-400 fill-amber-400`} data-id="element-330" />
            </div>
          </div>}
        {[...Array(emptyStars)].map((_, i) => <StarIcon key={`empty-${i}`} className={`${sizeStyles[size].star} text-slate-200 fill-slate-200`} data-id="element-331" />)}
      </div>
      {showCount && reviewCount !== undefined && <span className={`${sizeStyles[size].text} text-slate-500`} data-id="element-332">
          ({reviewCount})
        </span>}
    </div>;
}